// Client Customs — frontend API surface.

import { client } from '@platform/http/api-client';

const customsApi = {
  // Pages visible to the current user → { pages: [{ slug, name, ... }] }
  async customsList() {
    return (await client.get('/api/customs')).data;
  },
  // One page, config included (403 server-side for non-members).
  async customsGet(slug) {
    return (await client.get(`/api/customs/${encodeURIComponent(slug)}`)).data;
  },
  // Admin upsert: { name, description?, kind?, config?, restrictedGroups? }
  async customsPut(slug, payload) {
    return (await client.put(`/api/customs/${encodeURIComponent(slug)}`, payload)).data;
  },
  // Admin rename: { name, description? }. Config and access groups untouched
  // — the reason this is not customsPut.
  async customsRename(slug, payload) {
    return (await client.patch(`/api/customs/${encodeURIComponent(slug)}`, payload)).data;
  },
  // Admin access: { restrictedGroups: [group names] } — empty = every
  // signed-in user. The page's nav buttons are synced to the same groups
  // server-side; the response carries how many trees were rewritten.
  async customsSetAccess(slug, restrictedGroups) {
    return (await client.put(`/api/customs/${encodeURIComponent(slug)}/access`, { restrictedGroups })).data;
  },
  async customsDelete(slug) {
    return (await client.delete(`/api/customs/${encodeURIComponent(slug)}`)).data;
  },
  // Run a config-defined proxy endpoint → { status, body }. The secret side
  // (script variables) never leaves the server.
  async customsProxy(slug, endpoint, payload) {
    return (await client.post(
      `/api/customs/${encodeURIComponent(slug)}/proxy/${encodeURIComponent(endpoint)}`,
      payload || {},
    )).data;
  },
};

export default customsApi;
